import { useLayoutEffect } from 'react'

const SHELL_LOCK_CLASS = 'market-shell-active'

/** Locks document scroll while any market shell is mounted (buyer, supplier, operator). */
export const useMarketShellScrollLock = () => {
  useLayoutEffect(() => {
    const root = document.documentElement
    root.classList.add(SHELL_LOCK_CLASS)
    document.body.classList.add(SHELL_LOCK_CLASS)
    return () => {
      root.classList.remove(SHELL_LOCK_CLASS)
      document.body.classList.remove(SHELL_LOCK_CLASS)
    }
  }, [])
}
